<template>
    <div class="main">
        <div class="banner">
            <img src="../../assets/img/business/business_banner.png" alt="">
        </div>
        <div class="business-container">
            <div class="content">
                <div class="box">
                    <div class="pic-box">
                        <img src="../../assets/img/business/wyn.png" alt="">
                    </div>
                    <div class="pic-box">
                        <img src="../../assets/img/business/green.png" alt="">
                    </div>
                </div>
                <div class="box">
                    <div class="pic-box">
                        <img src="../../assets/img/business/yx.png" alt="">
                    </div>
                    <div class="pic-box">
                        <img src="../../assets/img/business/mh.png" alt="">
                    </div>
                </div>
                <div class="box">
                    <div class="pic-box">
                        <img src="../../assets/img/business/wdm.png" alt="">
                    </div>
                    <div class="pic-box">
                        <img src="../../assets/img/business/yd.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <hs-scroll></hs-scroll>
    </div>
</template>

<script>
    import HsScroll from '../scroll/HsScroll'
    export default {
        name: "Business",
        components: {
            HsScroll
        }
    }
</script>

<style scoped>
    .banner img {
        width: 100%;
    }

    .business-container {
        width: 100%;
    }

    .content {
        width: 1200px;
        margin: 0 auto;
        height: auto;
        background: url("../../assets/img/business/business-bg01.jpg") no-repeat;
        padding-bottom: 36px;
    }

    .box {
        display: flex;
    }

    .pic-box {
        flex: 1;
        text-align: center;
        margin-top: 50px;
    }
</style>